<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="this.procedimentosModal"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :disabled="isEdicao"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
export default {

    data() {
        return {
            fields: [
                {
                    key: 'codigo',
                    label: 'Código',
                    sortable: true,
                    class: 'col-min',
                },
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ],
        }
    },
    methods: {

        destroy(item) {

            this.procedimentosModal.splice(this.procedimentosModal.indexOf(item), 1)
        },
    },
    props: {
        isEdicao: { type: Boolean, default: false, },
        procedimentosModal: { type: Array, default: () => [], },
    },
}
</script>